import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const PlacesContent = ({data, boName}) => {
    const [limit, setLimit] = useState(15)
    const passedLimit = data.placesWithMoreBos.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 15)
    }

    useEffect(() => {
        const labels = ["Quantidade", "Endereço", "Bairro"];
        const values = [];

        const sorted = [...(data.placesWithMoreBos || [])];

        sorted.forEach((element) => {
            values.push([
                element.amount,
                ReportUtils.formatText(element.address),
                ReportUtils.formatText(element.neighborhood)
            ]);
        });

        ReportUtils.createExportableTable(labels, values, `${boName} por endereço`);
    }, [data]);

    return (
        <>
            <div id="address-table">
                <div className="chart mt-3">
                    <span id="address-title" className="chart-title">
                        {data.boName} por endereço {(passedLimit && limit) ? "(TOP 15)" : ""}
                    </span>
                </div>

                <table className="table report-table mt-2">
                    <thead className="thead-background">
                        <tr className={"text-left"}>
                            <th>Quantidade</th>
                            <th>Endereço</th>
                            <th>Bairro</th>
                        </tr>
                    </thead>

                    <tbody id="address-body" className={"bg-white"}>
                    {
                        (limit ? data.placesWithMoreBos.slice(0, limit) : data.placesWithMoreBos).map((d, index) => {
                            return(
                                <tr key={index}>
                                    <td>{d.amount}</td>
                                    <td>{ReportUtils.formatText(d.address)}</td>
                                    <td>{ReportUtils.formatText(d.neighborhood)}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>

                {
                    passedLimit &&
                    <div className="text-end mt-1">
                        <span id="toggle-nature" className="see-more print-hide" onClick={seeMoreOrLess}>
                            { limit ? "Ver mais" : "Ver menos" }
                        </span>
                    </div>
                }

            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default PlacesContent;